/**
 * Botón de «Salir».
 *
 * Después de cerrar sesión se invalida la consulta del perfil y se vuelve al
 * inicio. Lo segundo importa: quedarse en `/mi-cuenta` sin sesión dejaría a la
 * persona mirando la pantalla de «hace falta iniciar sesión» justo después de
 * haber pedido salir, que se lee como si el cierre hubiera fallado.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { cerrarSesion } from '../api/autenticacion'
import { textoDeError } from '../api/errores'
import { CLAVE_PERFIL } from './usePerfil'

export function BotonSalir() {
  const clienteDeConsultas = useQueryClient()
  const navegar = useNavigate()

  const salida = useMutation({
    mutationFn: cerrarSesion,
    onSuccess: async () => {
      await clienteDeConsultas.invalidateQueries({ queryKey: CLAVE_PERFIL })
      await navegar({ to: '/' })
    },
  })

  return (
    <span className="salir">
      <button
        type="button"
        className="boton"
        onClick={() => salida.mutate()}
        disabled={salida.isPending}
      >
        {salida.isPending ? 'Saliendo…' : 'Salir'}
      </button>
      {salida.isError && (
        <span className="salir__fallo" role="alert">
          {textoDeError(salida.error)}
        </span>
      )}
    </span>
  )
}
